export const cookies = [
  'functional-cookies',
  'analytical-cookies',
  'video-cookies',
  'tracking-cookies',
] as const

export type Cookie = typeof cookies[number]

export type CookieAccepted = "yes" | "no"

export type CookieName = 'functional-cookies' | 'analytical-cookies' | 'video-cookies' | 'tracking-cookies' 
export const requiredCookies: Cookie[] = ['functional-cookies', 'analytical-cookies']
